export default {
    state: {
      treeTableData: null,
      selectedTrees: [],
      selectedTreeInspections: [],
      redirectTreeToMap: false,
      redirectTreeInspectionToMap: false
    },
    mutations: {
      setTreeTableData(state, data) {
        state.treeTableData = data;
      },
      setSelectedTrees(state, data){
        state.selectedTrees = data;
      },
      setSelectedTreeInspections(state, data){
        state.selectedTreeInspections = data;
      },
      setRedirectTreeToMap(state, data){
        state.redirectTreeToMap = data;
      },
      setRedirectTreeInspectionToMap(state, data){
        state.redirectTreeInspectionToMap = data;
      }
    },
    actions: {
      fetchTreeTableData({ commit }, data) {
        commit("setTreeTableData", data);
      },
      setSelectedTrees ({ commit }, data) {
        commit('setSelectedTrees', data)
      },
      setSelectedTreeInspections ({ commit }, data) {
        commit('setSelectedTreeInspections', data)
      },
      setRedirectTreePageToMap ({ commit }, data) {
        commit('setRedirectTreeToMap', data)
      },
      setRedirectTreeInspectionPageToMap ({ commit }, data) {
        commit('setRedirectTreeInspectionToMap', data)
      }
    },
    getters: {
      getTableDataFromSQL: state => state.treeTableData,
      getSelectedTrees: state => state.selectedTrees,
      getSelectedTreeInspections: state => state.selectedTreeInspections,
      getRedirectTreePageToMap: state => state.redirectTreeToMap,
      getRedirectTreeInspectionPageToMap: state => state.redirectTreeInspectionToMap
    }
  };
